import { DollarCircleOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import styled from 'styled-components';

export const ContainerStyled = styled(`article`)<{ isActive: boolean }>`
	position: relative;
	padding: 24px;
	border: ${props => (props.isActive ? `2px solid #52C41A` : `2px solid #1890ff;`)};
	border-radius: 10px;
	background-color: ${props => {
		if (props.isActive) {
			return `#f7ffed`;
		}

		return `#fff`;
	}};
	font-size: 16px;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: 328px;
		padding: 16px;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 408px;
		padding: 24px;
	}
`;

export const PlanInfoContainerStyled = styled.div`
	width: 100%;
`;

export const PriceContainerStyled = styled(`div`)`
	display: flex;
	flex-direction: column;
	margin-bottom: 24px;
	font-weight: 600;
`;
export const TagContainerStyled = styled.div`
	position: absolute;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		top: 20px;
		right: 16px;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		top: 28px;
		right: 24px;
	}
	@media (min-width: ${props => props.theme.breakpoints.md}) {
		top: 28px;
		right: 24px;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		top: 28px;
		right: 24px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		top: 28px;
		right: 24px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		top: 28px;
		right: 24px;
	}
`;

export const NameStyled = styled.h2`
	margin: 0;
	font-weight: 600;
	line-height: 32px;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		font-size: 24px;
		margin-bottom: 16px;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 30px;
		margin-bottom: 28px;
	}
	@media (min-width: ${props => props.theme.breakpoints.md}) {
		font-size: 30px;
		margin-bottom: 28px;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		font-size: 30px;
		margin-bottom: 28px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		font-size: 30px;
		margin-bottom: 28px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		font-size: 30px;
		margin-bottom: 28px;
	}
`;

export const UsersInfoStyled = styled(Typography.Paragraph)`
	&.ant-typography {
		margin: 0;
		letter-spacing: -0.32px;
		font-weight: 400;
		font-style: normal;
		line-height: 24px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		font-size: 14px;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 14px;
	}
	@media (min-width: ${props => props.theme.breakpoints.md}) {
		font-size: 14px;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		font-size: 16px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		font-size: 16px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		font-size: 16px;
	}
`;

export const DollarIconStyled = styled(DollarCircleOutlined)`
	margin-left: 12px;
	width: 21px;
	height: 21px;
	color: #1890ff;
`;

export const PlanConditionStyled = styled.p`
	margin: 0;
	color: #8c8c8c;
	font-weight: 400;
	font-size: 14px;
`;

export const PlanConditionsContainerStyled = styled.div`
	margin-bottom: 20px;
`;

export const FeaturesListStyled = styled.div`
	gap: 12px;
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	align-items: flex-start;
`;

export const AdditionalFeaturesListStyled = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	align-items: flex-start;
`;

export const FeaturesListItemStyled = styled(`li`)`
	font-size: 14px;
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		font-size: 14px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		font-size: 14px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		font-size: 14px;
	}
`;
